export default __webpack_public_path__ + "static/media/Purple Pink Gradient Course Completion Certificate (2).07323d53.png";